import Vue from "vue";
import i18n from "../../i18n/i18n";

i18n.locale = window.document.documentElement.lang || "vi";

class ReportService {

    conversionsStatus = [
        {
            name: ('components.reportService.all'),
            value: [
                { name: ('components.reportService.conversionPending'), value: 0, },
                { name: ('components.reportService.conversionCancel'), value: -1, },
                { name: ('components.reportService.conversionSuccess'), value: 1, },
            ]
        }
    ];

    conversionsStatusNoGroup = [
        { name: ('components.reportService.all'), value: "", },
        { name: ('components.reportService.conversionPending'), value: 0, },
        { name: ('components.reportService.conversionCancel'), value: -1, },
        { name: ('components.reportService.conversionSuccess'), value: 1, },
    ]

    invoiceStatus = [
        { 
            name: ('components.reportService.all'), 
            value: [
                { name: ('components.reportService.invoiceNoProcess'), value: 0, },
                { name: ('components.reportService.invoiceProcessing'), value: 1, },
                { name: ('components.reportService.invoiceSuccess'), value: 2, },
            ]
        },
        
    ]

    invoiceStatusNoGroup = [
        { name: ('components.reportService.all'), value: "", },
        { name: ('components.reportService.invoiceNoProcess'), value: 0, },
        { name: ('components.reportService.invoiceProcessing'), value: 1, },
        { name: ('components.reportService.invoiceSuccess'), value: 2, },
    ]

    /**
     * @description Get report performance for chart
     * @since 2021.11.18
     * @deprecated 2021.12.12
     * @param {{ filter: Object, typeTime: "daily" | "hourly", fieldChartGroup: String}} data
     * @returns
     */
    async getPerformance(data = {}) {
        try {
            return await Vue.axios({
                method: "POST",
                url: "/report/performance/chart",
                data,
            });
        } catch(e) {
            return Promise.reject(e);
        }
    }

    /**
     * @description Get report revenue today overview
     * @since 2021.12.12
     * 
     * @returns Promise
     */
     async getTodayRevenue() {
        try {
            return await Vue.axios({
                method: "GET",
                url: `/report/performance/today`,
            });
        } catch(e) {
            return Promise.reject(e);
        }
    }

    /**
     * @description Get report summary list
     * @since 2021.11.18
     * @param {{date_from: String, date_to: String}} data 
     * @returns 
     */
    async getSummary(data = {
        date_from: "",
        date_to: ""
    }) {
        try {
            return await Vue.axios({
                method: "POST",
                url: "/overview/report-summary",
                data
            });
        } catch(e) {
            return Promise.reject(e);
        }
    }

    /**
     * @description Get list revenue week and month
     * @since 2021.11.18
     * @returns 
     */
    async revenueWeekAndMonth() {
        try {
            return await Vue.axios({
                method: "GET",
                url: `/report/revenue-week-and-month`
            });
        } catch(e) {
            return Promise.reject(e);
        }
    }
    
    /**
     * The api to get some data about payments. "all" || "invoice" || "advance-payment"
     * @param {{from_date, to_date, publisher_ids, type}} data 
     * @returns 
     */
    async payments(queryParams = {}) {
        try {
            return await Vue.axios.get("/report/invoice/payments", {
                params: queryParams,
            });
        } catch(e) {
            return Promise.reject(e);
        }
    }

    /**
     * @description Get list invoices report (periodic)
     * @since 2021.11.19
     * @param {{ status: Array }} data 
     * @returns 
     */
    async periodicInvoice(data = {}) {
        try {
            return await Vue.axios({
                method: "POST",
                url: "/report/invoice/periodic-invoice-report",
                data,
            })
        } catch(e) {
            return Promise.reject(e);
        }
    }
   
    /**
     * @description Get list invoices report (advance)
     * @since 2021.11.19
     * @param {{ status: Array }} data 
     * @returns 
     */
    async advanceInvoice(data = {}) {
        try {
            return await Vue.axios({
                method: "POST",
                url: "/report/invoice/advance-invoice-report",
                data,
            })
        } catch(e) {
            return Promise.reject(e);
        }
    }

    /**
     * @description Get overview report
     * @param {{ fromDate, toDate ,publisherId, publisherFilterType, conversionStatus, invoiceStatus, offerIds }} data 
     * @returns 
     */
    async reportOrderOverview(data = {}) {
        try {
            return await Vue.axios.post("/report/order/order-report-table", data);
        }
         catch(e) {
            return Promise.reject(e);
         }
    }
    
    /**
     * @description Get overview report detail
     * @param {{ offer_ids,conversionID,transactionID,clickID,from_date,to_date,conversion_status_codes, invoice_status_codes,publisherId,publisherFilterType,sort,currentPage,perPage, request_type, request_fields }} data 
     * @property {{request_type = "data" | "export"}}
     * 
     * @returns 
     */
    async reportOrderDetail(data = {}) {
        try {
            return await Vue.axios.post("/report/order/order-detail-report-table", data, {
                responseType: data.request_type === 'export' ? 'blob' : ''
            });
        }
        catch(e) {
            return Promise.reject(e);
        }
    }

    /**
     * @description Get export file includes all field in table report overview
     * @param {{startDate, endDate, publisherId, publisherFilterType, offerIds, conversionStatus}} data 
     * @returns 
     */
    async reportOrderOverviewExporting(data = {}) {
        try {
            return await Vue.axios.post("/report/order/order-report-table/export", data);
        }
        catch(e) {
            return Promise.reject(e);
        }
    }

    /**
     * @description Get export file includes all field in table report overview
     * @param {{ fromDate, toDate ,publisherId, publisherFilterType, conversionStatus, invoiceStatus, offerIds }} data 
     * @returns 
     */
    async reportOverviewTableExportExcel(data) {
        try {
            return Vue.axios.post("/report/order/order-report-table", data, {
                params: {
                    type: "export"
                },
                responseType: "blob"
            });
        } catch(e) {
            return Promise.reject(e);
        }
    }

    /**
     * @description Collect aff_sub
     * @param {{ publisherId, fromDate, toDate, offerIds, conversionStatus, invoiceStatus, field }}
     * @returns 
     */

    async collectAffSub(data) {
        try {
            const response = await Vue.axios.post("/report/aff_sub", data);
            return response;
        } catch(e) {
            return Promise.reject(e);
        }
    }
}

const reportService = new ReportService();

export default reportService;


// WEBPACK FOOTER //
// ./src/core/services/reportService.js